<template>
  <div>
    <div v-for="item in keysList" :key="item">
      <a-row>
        <a-col :span="colSpan">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="款项类型">
            <a-select
              placeholder="请选择款项类型"
              v-decorator="[
                `paymentType[${item}]`,
                {
                  initialValue: arr[item] ? arr[item].paymentType : undefined,
                  rules: [{ required: true, message: '请选择款项类型' }],
                },
              ]"
              :disabled="!isEdit"
            >
              <a-select-option v-for="(option, index) in PaymentTypeList" :key="index" :value="option.code">
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="colSpan">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划付款">
            <a-date-picker
              style="width: 100%"
              placeholder="请选择计划付款"
              v-decorator="[
                `paymentDatePlan[${item}]`,
                {
                  initialValue: arr[item] ? momentDate(arr[item].paymentDatePlan) : undefined,
                  rules: [{ required: true, message: '请选择计划付款' }],
                },
              ]"
              :disabled="!isEdit"
            />
          </a-form-item>
        </a-col>
        <a-col :span="colSpan">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款比例">
            <a-input
              placeholder="请输入付款比例"
              autocomplete="off"
              addon-after="%"
              v-decorator="[
                `paymentRatio[${item}]`,
                {
                  initialValue: arr[item] ? Ratio(arr[item].paymentRatio) : undefined,
                  rules: [{ required: true, message: '请输入收款比例' }],
                },
              ]"
              :disabled="!isEdit"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item style="float: right; margin-right: 32px">
            <a-button @click="removeRow(item)" :disabled="!isEdit">删除</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </div>
    <a-row type="flex" justify="center">
      <a-col :span="2">
        <a-button type="primary" icon="plus" @click="addRow" :disabled="!isEdit">添加</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    arr: {
      type: Array,
      default: function () {
        return []
      },
    },
    PaymentTypeList: [Array],
    form: [Object],
    type: [String],
  },
  data() {
    return {
      id: 0,
      keysList: [],
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      colSpan: 6,
    }
  },
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
  },
  created() {
    this.init()
  },
  methods: {
    getData() {
      const arr = []
      this.keysList.forEach( item => {
        const data = {
          paymentType: this.form.getFieldValue(`paymentType[${item}]`),
          paymentDatePlan: moment(this.form.getFieldValue(`paymentDatePlan[${item}]`)).format("YYYY-MM-DD"),
          paymentRatio: Number(this.form.getFieldValue(`paymentRatio[${item}]`)) / 100,
        }
        arr.push(data)
      })
      return arr
    },
    // 初始化
    init() {
      this.keysList = []
      this.model = {}
      this.id = 0
      const arr = [0]
      if (this.arr.length !== 0) {
        for (let i = 1; i < this.arr.length; i++) {
          arr.push(i)
          this.id = this.id + 1
        }
      }
      this.keysList = arr
      console.log('arr', this.arr)
      console.log('init', this.keysList)
    },
    // 移除某行
    removeRow(k) {
      if (this.keysList.length === 1) {
        // 如果存在可以移除所有行的情况，把条件改为this.keysList.length === 0即可
        this.clear(k)
        return
      }
      this.keysList = this.keysList.filter((item) => item !== k)
      console.log('del', this.keysList)
    },
    // 新增一行
    addRow() {
      this.id = this.id + 1
      this.keysList = this.keysList.concat(this.id)
      console.log('add', this.keysList)
    },
    momentDate(val) {
      return moment(val)
    },
    Ratio(val) {
      return Number(val) * 100
    },
    clear(item) {
      let paymentTypeArr = this.form.getFieldValue('paymentType')
      paymentTypeArr[item] = ''
      let paymentDatePlanArr = this.form.getFieldValue('paymentDatePlan')
      paymentDatePlanArr[item] = ''
      let paymentRatioArr = this.form.getFieldValue('paymentRatio')
      paymentRatioArr[item] = []
      this.form.setFieldsValue({
        paymentType: paymentTypeArr,
        paymentDatePlan: paymentDatePlanArr,
        paymentRatio: paymentRatioArr,
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>

